import { ReactComponent as ArrowDownSvg } from "./down-arrow.svg";
const ArrowDownIcon = (props) => {
  return <ArrowDownSvg {...props} />;
};
export default ArrowDownIcon;
